import {
  Order,
  RelationalOperatorKey,
} from '../../../utils/apollo/graphqlSchema';
import { TableSortType } from '../../Chart/interfaces';
export interface ColumnSortConfig {
  index?: number;
  sortType: TableSortType;
  sortOrder: Order;
}

export enum ColumnFilterType {
  Condition = 'CONDITION',
  Value = 'VALUE',
}
export interface ColumnFilterConfig {
  columnIndex?: number;
  condition: RelationalOperatorKey;
  values?: (string | number)[];
  type: ColumnFilterType;
}
